export const wantsBack = (event, searchValue) =>
  event.key === 'Escape' || (event.key === 'Backspace' && searchValue === '')
